export default __webpack_public_path__ + "static/media/shirt.6b47dc6b.svg";